// dashboard/conversationUser/Conversation.tsx
import React, { useEffect, useRef, useCallback, useState, useMemo } from "react";
import AppSimpleBar from "../../../components/AppSimpleBar";
import Loader from "../../../components/Loader";
import Message from "./Message";
import ForwardModal from "../../../components/ForwardModal";
import { IMessagesTypes, mapMessageToMessageTypes } from "../../../types/message";
import { IContactDetailsTypes, IProfileDetailsTypes } from "../../../types/profile";
import { useChat } from "../../../context/ChatContext";

interface ConversationProps {
  messages: IMessagesTypes[];
  chatUserDetails?: IContactDetailsTypes | null;

  onSetImgSelf: (messageId: string | number) => void;
  onSetImgDocument: (messageId: string | number) => void;
  onSetImgResidence: (messageId: string | number) => void;
  onSetImageAttachment: (messageId: string | number) => void;

  onDelete: (messageId: string | number) => void;
  onSetReplyData: (reply: null | IMessagesTypes) => void;
  isChannel: boolean;
  onOpenForward?: (message: IMessagesTypes) => void;
  onDeleteImage?: (messageId: string | number, imageId: string | number) => void;
  loading?: boolean;
}

const Conversation: React.FC<ConversationProps> = ({
  messages = [],
  chatUserDetails,

  onSetImgSelf,
  onSetImgDocument,
  onSetImgResidence,
  onSetImageAttachment,

  onDelete,
  onSetReplyData,
  isChannel,
  onDeleteImage,
  loading = false,
}) => {

  const ref = useRef<any>(null);
  const { selectedChatId } = useChat();

  // 1️⃣ Scroll ao trocar de chat
  // Scroll ao trocar de conversa (clique no chat)
  useEffect(() => {
    if (!ref.current) return;

    // Aguarda o DOM + SimpleBar renderizar
    const raf = requestAnimationFrame(() => {
      setTimeout(() => {
        const scrollElement = ref.current?.getScrollElement();
        if (scrollElement) {
          scrollElement.scrollTop = scrollElement.scrollHeight;
        }
      }, 50); // pequeno delay garante layout pronto
    });

    return () => cancelAnimationFrame(raf);
  }, [selectedChatId]); // 🔑 troca de chat


  // 2️⃣ Scroll apenas ao chegar nova mensagem
  const lastMessageCount = useRef(0);

  useEffect(() => {
    if (!ref.current) return;

    if (messages.length > lastMessageCount.current) {
      const el = ref.current.getScrollElement();
      if (el) el.scrollTop = el.scrollHeight;
    }

    lastMessageCount.current = messages.length;
  }, [messages]);


  /** ------------------- Forward Message ------------------- **/
  const [forwardData, setForwardData] = useState<null | IMessagesTypes>(null);
  const [isOpenForward, setIsOpenForward] = useState(false);

  const handleOpenForward = (message: IMessagesTypes) => {
    setForwardData(message);
    setIsOpenForward(true);
  };
  const handleCloseForward = () => setIsOpenForward(false);

  const handleForwardMessage = (data: any) => {
    console.log("[Forward Message]", {
      contacts: data.contacts,
      message: data.message,
      forwardedMessage: forwardData,
    });
  };

  return (
    <AppSimpleBar
      scrollRef={ref}
      className="chat-conversation p-3 p-lg-4 position-relative"
    >
      {loading && <Loader />}

      <ul className="list-unstyled chat-conversation-list" id="chat-conversation-list">
        {messages.map((message: IMessagesTypes, key: number) => {
          const isFromMe = message.meta.sender === 1 ? false : true;
          return (
            <Message
              // key={message.mId || key}
              // key={`${message.mId}-${message.reaction}`}
              key={`${message.mId}-${JSON.stringify(message)}`}
              message={message}

              chatUserDetails={chatUserDetails}
              onDelete={onDelete}
              onSetReplyData={onSetReplyData}
              isFromMe={isFromMe}
              onOpenForward={handleOpenForward}
              isChannel={isChannel}
              onDeleteImage={onDeleteImage || (() => { })}

              onSetImgSelf={onSetImgSelf}
              onSetImgDocument={onSetImgDocument}
              onSetImgResidence={onSetImgResidence}
              onSetImgAttachment={onSetImageAttachment}
            />
          );
        })}
      </ul>

      {isOpenForward && forwardData && (
        <ForwardModal
          isOpen={isOpenForward}
          onClose={handleCloseForward}
          forwardData={forwardData}
          chatUserDetails={chatUserDetails}
          onForward={handleForwardMessage}
        />
      )}
    </AppSimpleBar>
  );
};

export default Conversation;
